import { AuthService } from './../auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { TopicService } from '../service/topic/topic.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
// CAP-40007 TCL-22 - Centralized authorization service drives menu visibility.
import { AuthorizationService } from '../auth/authorization.service';
import { TclArea } from '../auth/roles.constants';

@Component({
  selector: 'app-topmenu',
  templateUrl: './topmenu.component.html',
  styleUrls: ['./topmenu.component.css']
})
export class TopmenuComponent implements OnInit {


  public isAdmin:boolean ; 
  public isExtract:boolean ;

  // CAP-40007 TCL-22 - Expose the area enum to the template for menu visibility checks.
  public TclArea = TclArea;

  constructor(private svc: TopicService,
    private translate: TranslateService,
    private router: Router,
    public authService : AuthService,
    // CAP-40007 TCL-22 - Inject the centralized authorization service.
    public authz: AuthorizationService) {

  }

  ngOnInit() {

    if(this.router.url.includes('saisie')){

      this.authService.isSaise.next(true);

    }else if(this.router.url.includes('administration')){
      this.isAdmin = true;
    }else if(this.router.url.includes('extraction')){
      this.isExtract = true;
    }
  }
  
  switchLanguage(language: string) {
    this.translate.use(language);
  }

  activate(event){
    
    switch(event){
      case 'Saisie':
      this.authService.isSaise.next(true);
      this.isAdmin = false;
      this.isExtract = false;
      break;
      case 'Administration':
      this.authService.isSaise.next(false);
      this.isAdmin = true;
      this.isExtract = false;
      break;
      case 'Extraction':
      this.authService.isSaise.next(false);
      this.isAdmin = false;
      this.isExtract = true;
      break;
    }
  }
} 